module.exports = __webpack_public_path__ + "img/05-424-424.dd4ea402.png";